import React, { useState } from 'react'
import { CallWithAuth } from '../../../../../action/apiActions'
import { GET_FREE_TAG, GET_LOD, GET_QUESTIOB_TYPE, GET_SUBJECT_TAG } from '../../../../../action/apiPath'
import { current } from '@reduxjs/toolkit'
import PrimaryTag from './PrimaryTag'
import SecondaryTag from './SecondaryTag'
import FreeTag from './FreeTag'
import { BasicInformation, Get_All_Category, QuestionCreationScreenBack, QuestionCreationScreenCancel } from '../../../../../redux/action'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import MediumModal from '../../../../atoms/Modal/MediumModal'

import style from '../../../../../assets/styles/createQuestion.module.css';
import SelectType from '../QuestionCreation/SelectType'

const BasicInfo = ({ id, getData, Draft }) => {
    // ________ initialization :start ____________
    const dispatch = useDispatch()
    const location = useLocation();
    const receivedState = location.state;
    const params = location.pathname
    const isEdit = params?.includes("edit")
    // console.log("receivedState", receivedState, params.includes("edit"))

    const selector = useSelector((state) => state.BasicInformationReducer)
    const selectorQuestion = useSelector((state) => state.QuestionScreenReducer)

    const { categoryList } = useSelector((state) => state.GetAllData);
    const navigate = useNavigate();
    // ________ initialization :end ____________


    // ________ STATE INITILIZATION ________
    const [format, setFormat] = useState(0)
    const [academicYear, setAcademicYear] = useState(null);
    const [category, setCategory] = useState(null);
    const [difficulty, setdifficulty] = useState(0)
    const [selectedPrimaryTag, setSelectedPrimaryTag] = useState(null)
    const [multiselectedSecondaryTag, setmultiSelectedSecondaryTag] = useState([])
    const [multiselectedfreeTag, setmultiSelectedfreeTag] = useState([])
    const [newFreeTag, setnewFreeTag] = useState([])

    const [groupName, setGroupName] = useState("")

    // ________body to send with disptach to action ________
    const body = {
        "format": format,
        "difficulty": difficulty,
        "primary_tag_id": selectedPrimaryTag?.id,
        "secondary_tags": multiselectedSecondaryTag?.map(item => item.id),
        "free_tags": multiselectedfreeTag?.map(item => item.id),
        "new_free_tags": newFreeTag,
        "category": category,
        "academic_year": academicYear,
    }





    // provide basic info SAVED to make status false
    const [saveButtonStatus, setSaveButtonStatus] = useState(false)
    const [saveButtonStatusGrouped, setSaveButtonStatusGrouped] = useState(false)

    useEffect(() => {
        if (selectedPrimaryTag !== null && multiselectedSecondaryTag.length !== 0) {
            setSaveButtonStatus(false)
        } else {
            setSaveButtonStatus(true)
        }
    }, [selectedPrimaryTag, multiselectedSecondaryTag])


    useEffect(() => {
        if (selectedPrimaryTag !== null && multiselectedSecondaryTag.length !== 0) {
            setSaveButtonStatusGrouped(false)
        } else {
            setSaveButtonStatusGrouped(true)
        }
    }, [selectedPrimaryTag, multiselectedSecondaryTag])


    // _____________ MODAL OPEN AND CLOSE _____________
    const [modalMedium, setModalMedium] = useState(false)
    const [modalData, setModalModalData] = useState({
        "title": "Are You Sure, Do You Want To Cancel Question Creation?",
        "description": "Your Current Changes Will Not Be Saved And You Will Be Redirected To Question Listing ",
        "cancelButton": "Continue Editing",
        "saveButton": "Yes, Cancel"
    })

    const openModalMedium = () => {
        setModalMedium(true)
    }

    const closeModalMedium = () => {
        setModalMedium(false)
    }

    // cancel button to send the user to question-bank 
    const Cancel = () => {
        navigate('/question-bank')
        dispatch(QuestionCreationScreenCancel())

    }


    const AddTagsFromReduxData = async () => {
        const PrimaryTagdata = await CallWithAuth("GET", GET_SUBJECT_TAG + "?ids=" + selector.primary_tag_id)
        if (PrimaryTagdata.status && PrimaryTagdata.res.status === 200) {
            setSelectedPrimaryTag(PrimaryTagdata.res.data[0])
        }

        const SecondaryTagdata = await CallWithAuth("GET", selector?.secondary_tags?.length === 0 ? GET_SUBJECT_TAG + "?ids=" + 0 : GET_SUBJECT_TAG + "?ids=" + selector.secondary_tags?.map(item => item),)
        // console.log("SecondaryTagdata",SecondaryTagdata)
        if (SecondaryTagdata.status && SecondaryTagdata.res.status === 200) {
            setmultiSelectedSecondaryTag(SecondaryTagdata.res.data)
        }

        if (selector?.free_tags?.length > 0) {
            const FreeTagdata = await CallWithAuth("GET", GET_FREE_TAG + "?ids=" + selector.free_tags?.map(item => item),)
            if (FreeTagdata.status && FreeTagdata.res.status === 200) {
                setmultiSelectedfreeTag(FreeTagdata.res.data)
            }
        }


    }

    // console.log("selector", selector)

    useEffect(() => {
        // setFormat(selector.format)
        // setdifficulty(selector.difficulty)
        AddTagsFromReduxData()
        // setSelectedPrimaryTag(selector.primary_tag_id)
    }, [selector])



    const [lod, setLod] = useState(null)

    const LODFUnction = async () => {
        const data = await CallWithAuth("GET", GET_LOD)

        if (data.status && data.res.status === 200) {
            setLod(data.res.data)
            // setdifficulty(data.res.data[0].id)
        }
    }

    useEffect(() => {
        LODFUnction()
        dispatch(Get_All_Category("", ""));
    }, [])


    const generateYears = () => {
        const currentYear = new Date().getFullYear();
        const startYear = 2011;
        const endYear = currentYear + 5;
        const years = [];
        for (let year = startYear; year <= endYear; year++) {
            years.push(year);
        }
        return years;
    };


    const [question, setQuestion] = useState([0, 1])
    const [questionbutton, setQuestionButton] = useState(0)



    //_______________ Fn for handle academic year
    // const handleAcademicYear = (e) => {
    //     const selectedYear = String(e.target.value);
    //     setAcademicYear(selectedYear);
    //     // console.log("My acadmecic year", selectedYear);
    // };

    //_______________ Fn for handle category
    // const handleCategory = (e) => {
    //     const selectedCategory = Number(e.target.value);
    //     setCategory(selectedCategory);
    // };



    const [GroupedBody, setGroupedQuestion] = useState({
        "question_group": [
            {
                "idx": 0,
                "question_type_id": null,
                "difficulty": null,
                "category": null,
                "academic_year": null,
                "primary_tag_id": null,
                "secondary_tags": [],
                "free_tags": [],
                "new_free_tags": [],
            },
            {
                "idx": 1,
                "question_type_id": null,
                "difficulty": null,
                "category": null,
                "academic_year": null,
                "primary_tag_id": null,
                "secondary_tags": [],
                "free_tags": [],
                "new_free_tags": [],
            }
        ],
        "group_name": groupName,
        "format": 1
    })


    // _______ TO close MULTIPLE QUESTION AND ANSWER for same screen _______
    const closeQuestion = () => {

        // Update the question array to remove the selected question
        const updatedQuestions = question?.filter(item => item !== questionbutton);
        const updatenewQuestion = question.slice(0,question.length-1)
        setQuestion(updatenewQuestion);

        // Update the GroupedBody state to ensure question_group length matches question length
        setGroupedQuestion(prevGroupedBody => ({
            ...prevGroupedBody,
            question_group: prevGroupedBody.question_group.slice(0, updatedQuestions.length)
        }));

        // Update the question button state
        if(questionbutton===0){
            setQuestionButton(0);
        }else{
            setQuestionButton(prevQuestionButton => prevQuestionButton - 1);
        }
        

    }
    
    console.log("question-->",question,questionbutton)

    useEffect(() => {
        if (getData) {
            if (Draft == 0) {
                if (getData.format == 0) {
                    setFormat(getData?.format == null ? 0 : getData?.format)
                    setdifficulty(getData?.difficulty)
                    setAcademicYear(getData?.academic_year)
                    setCategory(getData?.category)
                    setSelectedPrimaryTag(getData?.primary_tag)
                    setmultiSelectedSecondaryTag(getData?.secondary_tags)
                    setmultiSelectedfreeTag(getData?.free_tags)
                } else {
                    setFormat(getData[0]?.format == null ? 0 : getData[0]?.format)
                    const id = receivedState.question_id
                    const index = Array.isArray(getData) && getData?.findIndex(question => question.question_id === id)

                    const questionIndices = Array.isArray(getData) && getData?.map((items, index) => index);
                    setQuestion(questionIndices);
                    setQuestionButton(index)

                    const transformedData = Array.isArray(getData) && getData?.map((item, index) => ({
                        idx: index,
                        question_type_id: item?.question_type_id?.id || null,
                        difficulty: item?.difficulty,
                        category: item?.category,
                        academic_year: item?.academic_year,
                        primary_tag_id: item?.primary_tag?.id,
                        secondary_tags: item?.secondary_tags?.map(tag => tag.id),
                        free_tags: item?.free_tags?.map(tag => tag.id),
                        new_free_tags: [], // Assuming you want to leave this as an empty array
                    }));


                    if (transformedData?.length === 0) {
                        setGroupedQuestion(prevState => ({
                            ...prevState,
                            group_name: getData[0]?.group_name,
                            format: 1
                        }));

                        setQuestion([0, 1]);
                        setQuestionButton(0)

                    } else {
                        setGroupedQuestion(prevState => ({
                            ...prevState,
                            question_group: transformedData,
                            group_name: getData[0]?.group_name,
                            format: 1
                        }));
                    }

                }
            } else {
                if (getData[0].format == 0) {
                    setFormat(getData[0]?.format == null ? 0 : getData[0]?.format)
                    setdifficulty(getData[0]?.difficulty)
                    setAcademicYear(getData[0]?.academic_year)
                    setCategory(getData[0]?.category)
                    setSelectedPrimaryTag(getData[0]?.primary_tag)
                    setmultiSelectedSecondaryTag(getData[0]?.secondary_tags)
                    setmultiSelectedfreeTag(getData[0]?.free_tags)
                } else {
                    setFormat(getData[0]?.format == null ? 0 : getData[0]?.format)
                    const questionIndices = Array.isArray(getData) && getData[0]?.grouped_questions?.map((items, index) => index);
                    setQuestion(questionIndices);
                    setQuestionButton(0)

                    const transformedData = Array.isArray(getData) && getData[0]?.grouped_questions?.map((item, index) => ({
                        idx: index,
                        question_type_id: item?.question_type_id || null,
                        difficulty: item?.difficulty,
                        category: item?.category,
                        academic_year: item?.academic_year,
                        primary_tag_id: item?.primary_tag_id,
                        secondary_tags: item?.secondary_tags?.map(tag => tag),
                        free_tags: item?.free_tags?.map(tag => tag),
                        new_free_tags: [], // Assuming you want to leave this as an empty array
                    }));


                    if (transformedData?.length === 0) {
                        setGroupedQuestion(prevState => ({
                            ...prevState,
                            group_name: getData[0]?.group_name,
                            format: 1
                        }));

                        setQuestion([0, 1]);
                        setQuestionButton(0)

                    } else {
                        setGroupedQuestion(prevState => ({
                            ...prevState,
                            question_group: transformedData,
                            group_name: getData[0]?.group_name,
                            format: 1
                        }));
                    }


                }
            }
        }

    }, [getData])




    const [questionCategory, setQuestionCategory] = useState([])

    const GetQuestionTypeCategory = async () => {
        const category = await CallWithAuth("GET", GET_QUESTIOB_TYPE)
        if (category.status && category.res.status === 200) {

            const groupedData = {};

            category?.res?.data.forEach(item => {
                const category = item.category;
                if (!groupedData[category]) {
                    groupedData[category] = [];
                }
                groupedData[category].push(item);
            });

            // console.log("groupedData", groupedData["Data Analysis"]);
            setQuestionCategory(Object.values(groupedData).flat())

            // const onlyCategory = category?.res?.data?.map(items => items.category)
            // setQuestionCategory(Array.from(new Set(onlyCategory)))
        }
    }

    useEffect(() => {
        GetQuestionTypeCategory()
    }, [])




    //_______________ Fn for handle group name
    const handleGroupName = (e) => {
        const updatedBody = { ...GroupedBody };
        updatedBody.group_name = e.target.value;
        setGroupedQuestion(updatedBody);
    };

    const handleDifficultyLevel = (e) => {
        const updatedBody = { ...GroupedBody };
        updatedBody.question_group[questionbutton].difficulty = e;
        setGroupedQuestion(updatedBody);
    }


    const handleAcademicYear = (e) => {
        const updatedBody = { ...GroupedBody };
        updatedBody.question_group[questionbutton].academic_year = String(e.target.value);
        setGroupedQuestion(updatedBody);
    }

    const handleCategory = (e) => {
        const updatedBody = { ...GroupedBody };
        // console.log("uicheck",e.target.value)
        updatedBody.question_group[questionbutton].category = Number(e.target.value);
        setGroupedQuestion(updatedBody);
    }

    const handleQuestionType = (e) => {
        const updatedBody = { ...GroupedBody };
        updatedBody.question_group[questionbutton].question_type_id = Number(e);
        setGroupedQuestion(updatedBody);
    }

    useEffect(() => {
        if (selectedPrimaryTag != null) {
            if (format == 1) {
                const updatedBody = { ...GroupedBody };
                updatedBody.question_group[questionbutton].primary_tag_id = selectedPrimaryTag?.id;
                setGroupedQuestion(updatedBody);
            }
        }
    }, [selectedPrimaryTag])

    const RemovePrimaryTag = () => {
        if (format == 1) {
            const updatedBody = { ...GroupedBody };
            updatedBody.question_group[questionbutton].primary_tag_id = null;
            setGroupedQuestion(updatedBody);
        }
    }

    useEffect(() => {
        if (multiselectedSecondaryTag?.length > 0) {
            if (format == 1) {
                const updatedBody = { ...GroupedBody };
                updatedBody.question_group[questionbutton].secondary_tags = multiselectedSecondaryTag?.map(item => item.id);
                setGroupedQuestion(updatedBody);
            }
        }
    }, [multiselectedSecondaryTag])

    const RemoveSecondaryTag = () => {
        if (format == 1) {
            const updatedBody = { ...GroupedBody };
            updatedBody.question_group[questionbutton].secondary_tags = [];
            setGroupedQuestion(updatedBody);
        }
    }

    useEffect(() => {
        if (newFreeTag != null) {
            if (format == 1) {
                const updatedBody = { ...GroupedBody };
                updatedBody.question_group[questionbutton].new_free_tags = newFreeTag;
                setGroupedQuestion(updatedBody);
            }
        }
    }, [newFreeTag])


    useEffect(() => {
        if (multiselectedfreeTag.length > 0) {
            if (format == 1) {
                const updatedBody = { ...GroupedBody };
                updatedBody.question_group[questionbutton].free_tags = multiselectedfreeTag?.map(item => item.id);
                setGroupedQuestion(updatedBody);
            }
        }
    }, [multiselectedfreeTag])

    const RemovefreeTag = () => {
        if (format == 1) {
            const updatedBody = { ...GroupedBody };
            updatedBody.question_group[questionbutton].new_free_tags = [];
            updatedBody.question_group[questionbutton].free_tags = [];
            setGroupedQuestion(updatedBody);
        }
    }


    const AddQuestion = () => {
        setQuestion(current => [...current, question.length])

        setGroupedQuestion(prevBody => ({
            ...prevBody,
            question_group: [
                ...prevBody.question_group,
                {
                    "idx": GroupedBody.question_group.length,
                    "question_type_id": null,
                    "difficulty": null,
                    "category": null,
                    "academic_year": null,
                    "primary_tag_id": null,
                    "secondary_tags": null,
                    "free_tags": [],
                    "new_free_tags": [],
                }
            ]
        }));

    }



    console.log("format-->", format)

    return (
        <div className={style.select_question}>

            <div className={style.top_bar}>
                <div className={style.top_bar_title}>
                    <span>Add Basic Information</span>
                </div>
                <div>
                </div>
            </div>

            <div className={style.info}>
                {/* format  */}
                <div className={style.format}>
                    <div className={style.format_title}>
                        Choose Format <b className={style.red_mendantory}>*</b>
                    </div>
                    <div className={style.format_choice}>
                        <div>
                            <input type="radio" className={style.pointer} checked={format === 0} id="question" name="choose_question" value="Question" onClick={() => setFormat(0)} />
                            <label for="html">Single Question</label>
                        </div>
                        <div>
                            <input type="radio" className={style.pointer} checked={format === 1} id="question" name="choose_question" value="Question" onClick={() => setFormat(1)} />
                            <label for="html">Grouped Question</label>
                        </div>
                    </div>
                </div>

                {/*  ___________ code for single question ___________ */}
                {/* difficulty */}
                {/* {console.log("check",lod?.map((items,i)=>items.id),difficulty)} */}
                {format == 0 &&
                    <div className={style.format}>
                        <div className={style.format_title}>
                            Level of Difficulty <b className={style.red_mendantory}>*</b>
                        </div>
                        <div className={style.format_choice}>
                            {lod?.map((items, i) => (
                                <div>
                                    <input type="radio" className={style.pointer} checked={difficulty === items.id} id="difficulty" name="choose_difficulty" value="difficulty" onClick={() => setdifficulty(items.id)} />
                                    <label for="html">{items.level}</label>
                                </div>
                            ))}
                        </div>
                    </div>
                }
            </div>

            {format == 0 &&
                <div className={style.bound}>
                    <div className={style.templateDrop}>
                        <div className={style.templateDrop_item}>
                            <div className={style.templateGroup}>
                                <span>Academic Year </span>
                                <b className={style.red_mendantory}>*</b>
                                {/* {console.log("category1",academicYear,generateYears())} */}
                                <select
                                    name="question"
                                    id="question"
                                    value={academicYear == null ? "----- Select Academic Year -----" : academicYear}
                                    className={style.template_drop_filter}
                                    onChange={(e) => setAcademicYear(String(e.target.value))}
                                >
                                    <option value={null}>----- Select Academic Year -----</option>
                                    {generateYears().map((year) => (
                                        <option key={year} value={year}>
                                            {year}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className={style.templateDrop}>
                        <div className={style.templateDrop_item}>
                            <div className={style.templateGroup}>
                                <span>Category </span>
                                <b className={style.red_mendantory}>*</b>
                                {/* {console.log("category",category,categoryList)} */}
                                <select
                                    name="question"
                                    id="question"
                                    value={category == null ? "----- Select Category -----" : category}
                                    className={style.template_drop_filter}
                                    onChange={(e) => setCategory(Number(e.target.value))}
                                >
                                    <option value={null}>----- Select Category -----</option>
                                    {categoryList?.map((items, i) => (
                                        <option value={items.id}>{items.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            }

            {/* {console.log("getData-->", getData)} */}
            {/* ALL TAGS  */}
            {format == 0 && <>
                {Draft == 0 ?
                    <>
                        <PrimaryTag selectedPrimaryTag={selectedPrimaryTag} RemovePrimaryTag={RemovePrimaryTag} setSelectedPrimaryTag={setSelectedPrimaryTag} primary_id={getData?.primary_tag?.id} />
                        <SecondaryTag multiselectedSecondaryTag={multiselectedSecondaryTag} RemoveSecondaryTag={RemoveSecondaryTag} setmultiSelectedSecondaryTag={setmultiSelectedSecondaryTag} secondary_id={getData?.secondary_tags?.map((items) => items.id)} />
                        <FreeTag multiselectedfreeTag={multiselectedfreeTag} RemovefreeTag={RemovefreeTag} setmultiSelectedfreeTag={setmultiSelectedfreeTag} setnewFreeTag={setnewFreeTag} newFreeTag={newFreeTag} free_id={getData?.free_tags?.map((items) => items.id)} />
                    </>
                    :
                    <>
                        <PrimaryTag selectedPrimaryTag={selectedPrimaryTag} RemovePrimaryTag={RemovePrimaryTag} setSelectedPrimaryTag={setSelectedPrimaryTag} primary_id={getData[0]?.primary_tag?.id} />
                        <SecondaryTag multiselectedSecondaryTag={multiselectedSecondaryTag} RemoveSecondaryTag={RemoveSecondaryTag} setmultiSelectedSecondaryTag={setmultiSelectedSecondaryTag} secondary_id={getData[0]?.secondary_tags?.map((items) => items.id)} />
                        <FreeTag multiselectedfreeTag={multiselectedfreeTag} RemovefreeTag={RemovefreeTag} setmultiSelectedfreeTag={setmultiSelectedfreeTag} setnewFreeTag={setnewFreeTag} newFreeTag={newFreeTag} free_id={getData[0]?.free_tags?.map((items) => items.id)} />
                    </>}

                {/* SAVE BUTTON : dispatch */}
                <div className={style.saveButton_questionBank}>
                    <div className={` ${style.cancel} ${style.pointer}`} onClick={() => openModalMedium()}>
                        Cancel
                    </div>
                    <div>
                        <button className={saveButtonStatus ? `${style.blue_button_disable}` : `${style.blue_button}`} disabled={saveButtonStatus} onClick={() => dispatch(BasicInformation(body, id, 0))}>Save & Continue</button>
                    </div>
                </div>

            </>}
            {/*  ___________ code for single question ___________ */}

            {/*  ___________ code for group question ___________ */}

            {/* {console.log("GroupedBody",GroupedBody,format)}  */}
            {format == 1 &&
                <>
                    {console.log("GroupedBody", GroupedBody)}
                    {GroupedBody?.question_group?.filter((item, i) => item.idx === questionbutton)?.map((items, index) => (
                        <>
                            <div key={index} className={style.container} style={{ width: "100%" }}>
                                {question?.map((items, i) => (
                                    <button draggable="true" className={items === questionbutton ? ` ${style.multiquestionbutton} ${style.draggable}` : ` ${style.multiquestionbuttonBlue} ${style.draggable}`} onClick={() => setQuestionButton(i)}>

                                        {items === questionbutton ?
                                            <svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M3.4375 1.6875C3.4375 1.93473 3.36419 2.1764 3.22684 2.38196C3.08949 2.58752 2.89426 2.74774 2.66585 2.84235C2.43745 2.93696 2.18611 2.96171 1.94364 2.91348C1.70116 2.86525 1.47843 2.7462 1.30362 2.57138C1.1288 2.39657 1.00975 2.17384 0.961519 1.93136C0.913287 1.68889 0.938042 1.43755 1.03265 1.20915C1.12726 0.980739 1.28748 0.785516 1.49304 0.648164C1.6986 0.510812 1.94027 0.437501 2.1875 0.437501C2.51902 0.437501 2.83696 0.569197 3.07138 0.803617C3.3058 1.03804 3.4375 1.35598 3.4375 1.6875ZM7.8125 2.9375C8.05973 2.9375 8.3014 2.86419 8.50696 2.72684C8.71253 2.58949 8.87274 2.39426 8.96735 2.16585C9.06196 1.93745 9.08671 1.68611 9.03848 1.44364C8.99025 1.20116 8.8712 0.978433 8.69638 0.803617C8.52157 0.628801 8.29884 0.50975 8.05636 0.461519C7.81389 0.413287 7.56255 0.438042 7.33415 0.532651C7.10574 0.627261 6.91052 0.787477 6.77316 0.993038C6.63581 1.1986 6.5625 1.44027 6.5625 1.6875C6.5625 2.01902 6.6942 2.33696 6.92862 2.57138C7.16304 2.8058 7.48098 2.9375 7.8125 2.9375ZM2.1875 5.75C1.94027 5.75 1.6986 5.82331 1.49304 5.96066C1.28748 6.09802 1.12726 6.29324 1.03265 6.52165C0.938042 6.75005 0.913287 7.00139 0.961519 7.24386C1.00975 7.48634 1.1288 7.70907 1.30362 7.88388C1.47843 8.0587 1.70116 8.17775 1.94364 8.22598C2.18611 8.27421 2.43745 8.24946 2.66585 8.15485C2.89426 8.06024 3.08949 7.90003 3.22684 7.69446C3.36419 7.4889 3.4375 7.24723 3.4375 7C3.4375 6.66848 3.3058 6.35054 3.07138 6.11612C2.83696 5.8817 2.51902 5.75 2.1875 5.75ZM7.8125 5.75C7.56527 5.75 7.3236 5.82331 7.11804 5.96066C6.91248 6.09802 6.75226 6.29324 6.65765 6.52165C6.56304 6.75005 6.53829 7.00139 6.58652 7.24386C6.63475 7.48634 6.7538 7.70907 6.92862 7.88388C7.10343 8.0587 7.32616 8.17775 7.56864 8.22598C7.81111 8.27421 8.06245 8.24946 8.29086 8.15485C8.51926 8.06024 8.71449 7.90003 8.85184 7.69446C8.98919 7.4889 9.0625 7.24723 9.0625 7C9.0625 6.66848 8.9308 6.35054 8.69638 6.11612C8.46196 5.8817 8.14402 5.75 7.8125 5.75ZM2.1875 11.0625C1.94027 11.0625 1.6986 11.1358 1.49304 11.2732C1.28748 11.4105 1.12726 11.6057 1.03265 11.8341C0.938042 12.0626 0.913287 12.3139 0.961519 12.5564C1.00975 12.7988 1.1288 13.0216 1.30362 13.1964C1.47843 13.3712 1.70116 13.4903 1.94364 13.5385C2.18611 13.5867 2.43745 13.562 2.66585 13.4674C2.89426 13.3727 3.08949 13.2125 3.22684 13.007C3.36419 12.8014 3.4375 12.5597 3.4375 12.3125C3.4375 11.981 3.3058 11.663 3.07138 11.4286C2.83696 11.1942 2.51902 11.0625 2.1875 11.0625ZM7.8125 11.0625C7.56527 11.0625 7.3236 11.1358 7.11804 11.2732C6.91248 11.4105 6.75226 11.6057 6.65765 11.8341C6.56304 12.0626 6.53829 12.3139 6.58652 12.5564C6.63475 12.7988 6.7538 13.0216 6.92862 13.1964C7.10343 13.3712 7.32616 13.4903 7.56864 13.5385C7.81111 13.5867 8.06245 13.562 8.29086 13.4674C8.51926 13.3727 8.71449 13.2125 8.85184 13.007C8.98919 12.8014 9.0625 12.5597 9.0625 12.3125C9.0625 11.981 8.9308 11.663 8.69638 11.4286C8.46196 11.1942 8.14402 11.0625 7.8125 11.0625Z" fill="white" />
                                            </svg>
                                            : <svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M3.4375 1.6875C3.4375 1.93473 3.36419 2.1764 3.22684 2.38196C3.08949 2.58752 2.89426 2.74774 2.66585 2.84235C2.43745 2.93696 2.18611 2.96171 1.94364 2.91348C1.70116 2.86525 1.47843 2.7462 1.30362 2.57138C1.1288 2.39657 1.00975 2.17384 0.961519 1.93136C0.913287 1.68889 0.938042 1.43755 1.03265 1.20915C1.12726 0.980739 1.28748 0.785516 1.49304 0.648164C1.6986 0.510812 1.94027 0.437501 2.1875 0.437501C2.51902 0.437501 2.83696 0.569197 3.07138 0.803617C3.3058 1.03804 3.4375 1.35598 3.4375 1.6875ZM7.8125 2.9375C8.05973 2.9375 8.3014 2.86419 8.50696 2.72684C8.71253 2.58949 8.87274 2.39426 8.96735 2.16585C9.06196 1.93745 9.08671 1.68611 9.03848 1.44364C8.99025 1.20116 8.8712 0.978433 8.69638 0.803617C8.52157 0.628801 8.29884 0.50975 8.05636 0.461519C7.81389 0.413287 7.56255 0.438042 7.33415 0.532651C7.10574 0.627261 6.91052 0.787477 6.77316 0.993038C6.63581 1.1986 6.5625 1.44027 6.5625 1.6875C6.5625 2.01902 6.6942 2.33696 6.92862 2.57138C7.16304 2.8058 7.48098 2.9375 7.8125 2.9375ZM2.1875 5.75C1.94027 5.75 1.6986 5.82331 1.49304 5.96066C1.28748 6.09802 1.12726 6.29324 1.03265 6.52165C0.938042 6.75005 0.913287 7.00139 0.961519 7.24386C1.00975 7.48634 1.1288 7.70907 1.30362 7.88388C1.47843 8.0587 1.70116 8.17775 1.94364 8.22598C2.18611 8.27421 2.43745 8.24946 2.66585 8.15485C2.89426 8.06024 3.08949 7.90003 3.22684 7.69446C3.36419 7.4889 3.4375 7.24723 3.4375 7C3.4375 6.66848 3.3058 6.35054 3.07138 6.11612C2.83696 5.8817 2.51902 5.75 2.1875 5.75ZM7.8125 5.75C7.56527 5.75 7.3236 5.82331 7.11804 5.96066C6.91248 6.09802 6.75226 6.29324 6.65765 6.52165C6.56304 6.75005 6.53829 7.00139 6.58652 7.24386C6.63475 7.48634 6.7538 7.70907 6.92862 7.88388C7.10343 8.0587 7.32616 8.17775 7.56864 8.22598C7.81111 8.27421 8.06245 8.24946 8.29086 8.15485C8.51926 8.06024 8.71449 7.90003 8.85184 7.69446C8.98919 7.4889 9.0625 7.24723 9.0625 7C9.0625 6.66848 8.9308 6.35054 8.69638 6.11612C8.46196 5.8817 8.14402 5.75 7.8125 5.75ZM2.1875 11.0625C1.94027 11.0625 1.6986 11.1358 1.49304 11.2732C1.28748 11.4105 1.12726 11.6057 1.03265 11.8341C0.938042 12.0626 0.913287 12.3139 0.961519 12.5564C1.00975 12.7988 1.1288 13.0216 1.30362 13.1964C1.47843 13.3712 1.70116 13.4903 1.94364 13.5385C2.18611 13.5867 2.43745 13.562 2.66585 13.4674C2.89426 13.3727 3.08949 13.2125 3.22684 13.007C3.36419 12.8014 3.4375 12.5597 3.4375 12.3125C3.4375 11.981 3.3058 11.663 3.07138 11.4286C2.83696 11.1942 2.51902 11.0625 2.1875 11.0625ZM7.8125 11.0625C7.56527 11.0625 7.3236 11.1358 7.11804 11.2732C6.91248 11.4105 6.75226 11.6057 6.65765 11.8341C6.56304 12.0626 6.53829 12.3139 6.58652 12.5564C6.63475 12.7988 6.7538 13.0216 6.92862 13.1964C7.10343 13.3712 7.32616 13.4903 7.56864 13.5385C7.81111 13.5867 8.06245 13.562 8.29086 13.4674C8.51926 13.3727 8.71449 13.2125 8.85184 13.007C8.98919 12.8014 9.0625 12.5597 9.0625 12.3125C9.0625 11.981 8.9308 11.663 8.69638 11.4286C8.46196 11.1942 8.14402 11.0625 7.8125 11.0625Z" fill="#272727" />
                                            </svg>} &nbsp;

                                        Question {i + 1}
                                    </button>
                                ))}

                            </div>

                            {/* Add question button: to add more answer  */}
                            <div style={{ display: "flex", marginTop: "20px", marginBottom: "20px" }}>


                                <div className={` ${style.Add_answer} ${style.pointer}`} style={{ marginTop: "0px" }} onClick={() => AddQuestion()} >
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z" stroke="#00ABFB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M7.5 12H16.5" stroke="#00ABFB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M12 16.5V7.5" stroke="#00ABFB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    <span>Add Question</span>
                                </div>

                                {/* Current QUESTION RUNNING  */}
                                <div className={style.questions_remove}>
                                    {/* <div className={style.titles}>
                            <span>Question {questionbutton + 1}</span>
                        </div> */}

                                    {!isEdit ? <>
                                        {question.length > 2 ? <div className={style.remove} style={{ width: "100%" }} >
                                            <button className={` ${style.remove_question} ${style.pointer}`} onClick={() => closeQuestion()}>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M18.8504 9.14062L18.2004 19.2106C18.0904 20.7806 18.0004 22.0006 15.2104 22.0006H8.79039C6.00039 22.0006 5.91039 20.7806 5.80039 19.2106L5.15039 9.14062" stroke="#272727" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M21 5.98047C17.67 5.65047 14.32 5.48047 10.98 5.48047C9 5.48047 7.02 5.58047 5.04 5.78047L3 5.98047" stroke="#272727" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97" stroke="#272727" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                                &nbsp;
                                                <span>Remove</span>
                                            </button>
                                        </div> : ""}
                                    </> : ""}

                                </div>

                            </div>

                            <div className={style.bound}>
                                <div className={style.templateDrop}>
                                    <div className={style.templateDrop_item}>
                                        <div className={style.templateGroup}>
                                            <span>Group Name </span>
                                            <b className={style.red_mendantory}>*</b>
                                            <input
                                                value={GroupedBody.group_name}
                                                onChange={handleGroupName}
                                                placeholder="Group Name"
                                                className={style.textInput}
                                            />
                                        </div>
                                    </div>
                                </div>


                            </div>

                            <hr />

                            <div key={index} className={style.info}>
                                <div className={style.format}>
                                    <div className={style.format_title}>
                                        Level of Difficulty <b className={style.red_mendantory}>*</b>
                                    </div>
                                    <div className={style.format_choice}>
                                        {lod?.map((items, i) => (
                                            <div>
                                                <input type="radio" className={style.pointer} checked={GroupedBody.question_group[questionbutton].difficulty === items.id} id="difficulty" name="choose_difficulty" value="difficulty" onClick={() => handleDifficultyLevel(items.id)} />
                                                <label for="html">{items.level}</label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <div key={index} className={style.bound}>
                                <div className={style.templateDrop} key={index}>
                                    <div className={style.templateDrop_item}>
                                        <div className={style.templateGroup}>
                                            <span>Academic Year </span>
                                            <b className={style.red_mendantory}>*</b>
                                            {/* {console.log("category1",items.academic_year,generateYears())} */}
                                            <select
                                                name="question"
                                                id="question"
                                                className={style.template_drop_filter}
                                                onChange={(e) => handleAcademicYear(e)}
                                                value={items.academic_year == null ? "----- Select Academic Year -----" : items.academic_year}
                                            >
                                                <option value={null}>----- Select Academic Year -----</option>
                                                {generateYears().map((year) => (
                                                    <option key={year} value={year}>
                                                        {year}
                                                    </option>
                                                ))}
                                            </select>

                                        </div>
                                    </div>
                                </div>

                                <div className={style.templateDrop}>
                                    <div className={style.templateDrop_item}>
                                        <div className={style.templateGroup}>
                                            <span>Category </span>
                                            <b className={style.red_mendantory}>*</b>
                                            {/* {console.log("category",items.category,categoryList)} */}
                                            <select
                                                name="question"
                                                id="question"
                                                className={style.template_drop_filter}
                                                onChange={(e) => handleCategory(e)}
                                                value={items.category == null ? "----- Select Category -----" : items.category}
                                            >
                                                <option value={null}>----- Select Category -----</option>
                                                {categoryList?.map((item, i) => (
                                                    <option value={item.id}>{item.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <PrimaryTag questionbutton={questionbutton} RemovePrimaryTag={RemovePrimaryTag} selectedPrimaryTag={selectedPrimaryTag} setSelectedPrimaryTag={setSelectedPrimaryTag} primary_id={GroupedBody.question_group[questionbutton].primary_tag_id} />
                            <SecondaryTag questionbutton={questionbutton} RemoveSecondaryTag={RemoveSecondaryTag} multiselectedSecondaryTag={multiselectedSecondaryTag} setmultiSelectedSecondaryTag={setmultiSelectedSecondaryTag} secondary_id={GroupedBody.question_group[questionbutton].secondary_tags} />
                            <FreeTag questionbutton={questionbutton} RemovefreeTag={RemovefreeTag} multiselectedfreeTag={multiselectedfreeTag} setmultiSelectedfreeTag={setmultiSelectedfreeTag} setnewFreeTag={setnewFreeTag} newFreeTag={newFreeTag} free_id={GroupedBody.question_group[questionbutton].free_tags} />


                            {questionCategory?.filter((item, i) => item.id == GroupedBody.question_group[questionbutton].question_type_id)?.map((items, i) =>
                                <div className={style.question_creating} style={{ height: "5%", marginBottom: "30px" }}>
                                    <div>
                                        <div className={style.question_creating_title}>

                                            <span>{items.category} - {items.name} </span>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M19.9201 8.94922L13.4001 15.4692C12.6301 16.2392 11.3701 16.2392 10.6001 15.4692L4.08008 8.94922" stroke="#212529" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>

                                        </div>
                                    </div>
                                </div>
                            )}


                            <SelectType id={id} index={index} selectedID={GroupedBody.question_group[questionbutton].question_type_id} data={selectorQuestion} format={format} handleQuestionType={handleQuestionType} />

                        </>
                    ))}

                    <div className={style.saveButton_questionBank} style={{ marginTop: "30px" }}>
                        <div className={` ${style.cancel} ${style.pointer}`} onClick={() => openModalMedium()}>
                            Cancel
                        </div>
                        <div>
                            <button className={saveButtonStatusGrouped ? `${style.blue_button_disable}` : `${style.blue_button}`}
                                // disabled={saveButtonStatus} 
                                onClick={() => dispatch(BasicInformation(GroupedBody, id, 1))}>Save & Continue</button>
                        </div>
                    </div>
                </>
            }

            {/*  ___________ code for group question ___________ */}

            <MediumModal modalMedium={modalMedium} forwardButton={() => Cancel()} openModalMedium={openModalMedium} closeModalMedium={closeModalMedium} modalData={modalData} />

        </div>
    )
}

export default BasicInfo